export const normalizePath = (pathname) => {
  const uuidRegex = /\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/gi;

  const objectIdRegex = /\b[0-9a-f]{24}\b/gi;

  const hexRegex = /\b[0-9a-f]{24,32}\b/gi;

  return pathname
    .replace(uuidRegex, 'id')
    .replace(objectIdRegex, 'id')
    .replace(hexRegex, 'id');
};

export const getPageName = (pathname) => {
  if (!pathname || pathname === '/') {
    return 'Home';
  }

  const firstSegment = pathname.split('/').filter(Boolean)[0];
  if (!firstSegment) {
    return 'Home';
  }

  return firstSegment
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const findClickableElement = (e) => {
  const start = e?.target;
  if (!start) return null;

  const clickable = start.closest?.(
    '[data-ph-click], a, button, [role="button"], [role="link"]'
  );
  if (!clickable) return null;

  const hasTag = (tag) => clickable.localName?.toLowerCase() === tag;

  if (clickable.hasAttribute('data-ph-click')) {
    const element = `${clickable.getAttribute('data-ph-click')}`;
    const text =
      (
        clickable.getAttribute('data-label') ||
        clickable.innerText ||
        ''
      ).trim() || 'without text';
    const toPath = clickable.getAttribute('data-route') || null;

    return {element, text, toPath, el: clickable};
  }

  let tag = clickable.localName?.toLowerCase();
  if (tag === 'a' && clickable?.className?.includes('Button')) tag = 'button';
  if (tag === 'a' && !clickable?.className?.includes('Button')) tag = 'link';

  const text = (clickable.innerText || '').trim() || 'without text';
  let toPath = null;

  if (hasTag('a') && clickable.href) {
    try {
      const url = new URL(clickable.href, window.location.origin);
      toPath = url.pathname + url.search + url.hash;
    } catch {
      toPath = null;
    }
  }

  return {element: tag, text, toPath, el: clickable};
};
